export interface ICountry {
  name: string;
  value: string;
  countryCode?: string;
  countryName: string;
}

export type TCountryOption = {
  label: string;
  value: string;
  countryCode?: string;
};

export const Countries: ICountry[] = [
  {
    countryName: 'Andorra',
    name: 'Andorra - Europe/Andorra',
    value: 'Europe/Andorra',
  },
  {
    countryName: 'United Arab Emirates',
    name: 'United Arab Emirates - Asia/Dubai',
    value: 'Asia/Dubai',
    countryCode: 'AE',
  },
  {
    countryName: 'Afghanistan',
    name: 'Afghanistan - Asia/Kabul',
    value: 'Asia/Kabul',
    countryCode: 'AF',
  },
  {
    countryName: 'Antigua and Barbuda',
    name: 'Antigua and Barbuda - America/Antigua',
    value: 'America/Antigua',
  },
  {
    countryName: 'Anguilla',
    name: 'Anguilla - America/Anguilla',
    value: 'America/Anguilla',
  },
  {
    countryName: 'Albania',
    name: 'Albania - Europe/Tirane',
    value: 'Europe/Tirane',
    countryCode: 'AL',
  },
  {
    countryName: 'Armenia',
    name: 'Armenia - Asia/Yerevan',
    value: 'Asia/Yerevan',
    countryCode: 'AM',
  },
  {
    countryName: 'Angola',
    name: 'Angola - Africa/Luanda',
    value: 'Africa/Luanda',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Casey',
    value: 'Antarctica/Casey',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Davis',
    value: 'Antarctica/Davis',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/DumontDUrville',
    value: 'Antarctica/DumontDUrville',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Mawson',
    value: 'Antarctica/Mawson',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/McMurdo',
    value: 'Antarctica/McMurdo',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Palmer',
    value: 'Antarctica/Palmer',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Rothera',
    value: 'Antarctica/Rothera',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Syowa',
    value: 'Antarctica/Syowa',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Troll',
    value: 'Antarctica/Troll',
  },
  {
    countryName: 'Antarctica',
    name: 'Antarctica - Antarctica/Vostok',
    value: 'Antarctica/Vostok',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Buenos_Aires',
    value: 'America/Argentina/Buenos_Aires',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Catamarca',
    value: 'America/Argentina/Catamarca',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Cordoba',
    value: 'America/Argentina/Cordoba',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Jujuy',
    value: 'America/Argentina/Jujuy',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/La_Rioja',
    value: 'America/Argentina/La_Rioja',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Mendoza',
    value: 'America/Argentina/Mendoza',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Rio_Gallegos',
    value: 'America/Argentina/Rio_Gallegos',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Salta',
    value: 'America/Argentina/Salta',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/San_Juan',
    value: 'America/Argentina/San_Juan',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/San_Luis',
    value: 'America/Argentina/San_Luis',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Tucuman',
    value: 'America/Argentina/Tucuman',
    countryCode: 'AR',
  },
  {
    countryName: 'Argentina',
    name: 'Argentina - America/Argentina/Ushuaia',
    value: 'America/Argentina/Ushuaia',
    countryCode: 'AR',
  },
  {
    countryName: 'American Samoa',
    name: 'American Samoa - Pacific/Pago_Pago',
    value: 'Pacific/Pago_Pago',
  },
  {
    countryName: 'Austria',
    name: 'Austria - Europe/Vienna',
    value: 'Europe/Vienna',
    countryCode: 'AT',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Antarctica/Macquarie',
    value: 'Antarctica/Macquarie',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Adelaide',
    value: 'Australia/Adelaide',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Brisbane',
    value: 'Australia/Brisbane',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Broken_Hill',
    value: 'Australia/Broken_Hill',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Currie',
    value: 'Australia/Currie',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Darwin',
    value: 'Australia/Darwin',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Eucla',
    value: 'Australia/Eucla',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Hobart',
    value: 'Australia/Hobart',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Lindeman',
    value: 'Australia/Lindeman',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Lord_Howe',
    value: 'Australia/Lord_Howe',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Melbourne',
    value: 'Australia/Melbourne',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Perth',
    value: 'Australia/Perth',
    countryCode: 'AU',
  },
  {
    countryName: 'Australia',
    name: 'Australia - Australia/Sydney',
    value: 'Australia/Sydney',
    countryCode: 'AU',
  },
  {
    countryName: 'Aruba',
    name: 'Aruba - America/Aruba',
    value: 'America/Aruba',
  },
  {
    countryName: 'Aland Islands',
    name: 'Aland Islands - Europe/Mariehamn',
    value: 'Europe/Mariehamn',
  },
  {
    countryName: 'Azerbaijan',
    name: 'Azerbaijan - Asia/Baku',
    value: 'Asia/Baku',
    countryCode: 'AZ',
  },
  {
    countryName: 'Bosnia and Herzegovina',
    name: 'Bosnia and Herzegovina - Europe/Sarajevo',
    value: 'Europe/Sarajevo',
    countryCode: 'BA',
  },
  {
    countryName: 'Barbados',
    name: 'Barbados - America/Barbados',
    value: 'America/Barbados',
  },
  {
    countryName: 'Bangladesh',
    name: 'Bangladesh - Asia/Dhaka',
    value: 'Asia/Dhaka',
    countryCode: 'BD',
  },
  {
    countryName: 'Belgium',
    name: 'Belgium - Europe/Brussels',
    value: 'Europe/Brussels',
    countryCode: 'BE',
  },
  {
    countryName: 'Burkina Faso',
    name: 'Burkina Faso - Africa/Ouagadougou',
    value: 'Africa/Ouagadougou',
  },
  {
    countryName: 'Bulgaria',
    name: 'Bulgaria - Europe/Sofia',
    value: 'Europe/Sofia',
    countryCode: 'BG',
  },
  {
    countryName: 'Bahrain',
    name: 'Bahrain - Asia/Bahrain',
    value: 'Asia/Bahrain',
    countryCode: 'BH',
  },
  {
    countryName: 'Burundi',
    name: 'Burundi - Africa/Bujumbura',
    value: 'Africa/Bujumbura',
  },
  {
    countryName: 'Benin',
    name: 'Benin - Africa/Porto-Novo',
    value: 'Africa/Porto-Novo',
  },
  {
    countryName: 'Saint Barthélemy',
    name: 'Saint Barthélemy - America/St_Barthelemy',
    value: 'America/St_Barthelemy',
  },
  {
    countryName: 'Bermuda',
    name: 'Bermuda - Atlantic/Bermuda',
    value: 'Atlantic/Bermuda',
  },
  {
    countryName: 'Brunei',
    name: 'Brunei - Asia/Brunei',
    value: 'Asia/Brunei',
    countryCode: 'BN',
  },
  {
    countryName: 'Bolivia',
    name: 'Bolivia - America/La_Paz',
    value: 'America/La_Paz',
    countryCode: 'BO',
  },
  {
    countryName: 'Bonaire, Saint Eustatius and Saba',
    name: 'Bonaire, Saint Eustatius and Saba  - America/Kralendijk',
    value: 'America/Kralendijk',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Araguaina',
    value: 'America/Araguaina',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Bahia',
    value: 'America/Bahia',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Belem',
    value: 'America/Belem',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Boa_Vista',
    value: 'America/Boa_Vista',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Campo_Grande',
    value: 'America/Campo_Grande',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Cuiaba',
    value: 'America/Cuiaba',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Eirunepe',
    value: 'America/Eirunepe',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Fortaleza',
    value: 'America/Fortaleza',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Maceio',
    value: 'America/Maceio',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Manaus',
    value: 'America/Manaus',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Noronha',
    value: 'America/Noronha',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Porto_Velho',
    value: 'America/Porto_Velho',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Recife',
    value: 'America/Recife',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Rio_Branco',
    value: 'America/Rio_Branco',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Santarem',
    value: 'America/Santarem',
    countryCode: 'BR',
  },
  {
    countryName: 'Brazil',
    name: 'Brazil - America/Sao_Paulo',
    value: 'America/Sao_Paulo',
    countryCode: 'BR',
  },
  {
    countryName: 'Bahamas',
    name: 'Bahamas - America/Nassau',
    value: 'America/Nassau',
  },
  {
    countryName: 'Bhutan',
    name: 'Bhutan - Asia/Thimphu',
    value: 'Asia/Thimphu',
    countryCode: 'BT',
  },
  {
    countryName: 'Botswana',
    name: 'Botswana - Africa/Gaborone',
    value: 'Africa/Gaborone',
    countryCode: 'BW',
  },
  {
    countryName: 'Belarus',
    name: 'Belarus - Europe/Minsk',
    value: 'Europe/Minsk',
    countryCode: 'BY',
  },
  {
    countryName: 'Belize',
    name: 'Belize - America/Belize',
    value: 'America/Belize',
    countryCode: 'BZ',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Atikokan',
    value: 'America/Atikokan',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Blanc-Sablon',
    value: 'America/Blanc-Sablon',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Cambridge_Bay',
    value: 'America/Cambridge_Bay',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Creston',
    value: 'America/Creston',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Dawson',
    value: 'America/Dawson',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Dawson_Creek',
    value: 'America/Dawson_Creek',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Edmonton',
    value: 'America/Edmonton',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Fort_Nelson',
    value: 'America/Fort_Nelson',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Glace_Bay',
    value: 'America/Glace_Bay',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Goose_Bay',
    value: 'America/Goose_Bay',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Halifax',
    value: 'America/Halifax',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Inuvik',
    value: 'America/Inuvik',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Iqaluit',
    value: 'America/Iqaluit',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Moncton',
    value: 'America/Moncton',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Nipigon',
    value: 'America/Nipigon',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Pangnirtung',
    value: 'America/Pangnirtung',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Rainy_River',
    value: 'America/Rainy_River',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Rankin_Inlet',
    value: 'America/Rankin_Inlet',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Regina',
    value: 'America/Regina',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Resolute',
    value: 'America/Resolute',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/St_Johns',
    value: 'America/St_Johns',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Swift_Current',
    value: 'America/Swift_Current',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Thunder_Bay',
    value: 'America/Thunder_Bay',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Toronto',
    value: 'America/Toronto',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Vancouver',
    value: 'America/Vancouver',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Whitehorse',
    value: 'America/Whitehorse',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Winnipeg',
    value: 'America/Winnipeg',
    countryCode: 'CA',
  },
  {
    countryName: 'Canada',
    name: 'Canada - America/Yellowknife',
    value: 'America/Yellowknife',
    countryCode: 'CA',
  },
  {
    countryName: 'Cocos Islands',
    name: 'Cocos Islands - Indian/Cocos',
    value: 'Indian/Cocos',
  },
  {
    countryName: 'Democratic Republic of the Congo',
    name: 'Democratic Republic of the Congo - Africa/Kinshasa',
    value: 'Africa/Kinshasa',
    countryCode: 'CD',
  },
  {
    countryName: 'Democratic Republic of the Congo',
    name: 'Democratic Republic of the Congo - Africa/Lubumbashi',
    value: 'Africa/Lubumbashi',
    countryCode: 'CD',
  },
  {
    countryName: 'Central African Republic',
    name: 'Central African Republic - Africa/Bangui',
    value: 'Africa/Bangui',
  },
  {
    countryName: 'Republic of the Congo',
    name: 'Republic of the Congo - Africa/Brazzaville',
    value: 'Africa/Brazzaville',
  },
  {
    countryName: 'Switzerland',
    name: 'Switzerland - Europe/Zurich',
    value: 'Europe/Zurich',
    countryCode: 'CH',
  },
  {
    countryName: 'Ivory Coast',
    name: 'Ivory Coast - Africa/Abidjan',
    value: 'Africa/Abidjan',
    countryCode: 'CI',
  },
  {
    countryName: 'Cook Islands',
    name: 'Cook Islands - Pacific/Rarotonga',
    value: 'Pacific/Rarotonga',
  },
  {
    countryName: 'Chile',
    name: 'Chile - America/Punta_Arenas',
    value: 'America/Punta_Arenas',
  },
  {
    countryName: 'Chile',
    name: 'Chile - America/Santiago',
    value: 'America/Santiago',
    countryCode: 'CL',
  },
  {
    countryName: 'Chile',
    name: 'Chile - Pacific/Easter',
    value: 'Pacific/Easter',
    countryCode: 'CL',
  },
  {
    countryName: 'Cameroon',
    name: 'Cameroon - Africa/Douala',
    value: 'Africa/Douala',
    countryCode: 'CM',
  },
  {
    countryName: 'China',
    name: 'China - Asia/Shanghai',
    value: 'Asia/Shanghai',
    countryCode: 'CN',
  },
  {
    countryName: 'China',
    name: 'China - Asia/Urumqi',
    value: 'Asia/Urumqi',
    countryCode: 'CN',
  },
  {
    countryName: 'Colombia',
    name: 'Colombia - America/Bogota',
    value: 'America/Bogota',
    countryCode: 'CO',
  },
  {
    countryName: 'Costa Rica',
    name: 'Costa Rica - America/Costa_Rica',
    value: 'America/Costa_Rica',
    countryCode: 'CR',
  },
  {
    countryName: 'Cuba',
    name: 'Cuba - America/Havana',
    value: 'America/Havana',
    countryCode: 'CU',
  },
  {
    countryName: 'Cape Verde',
    name: 'Cape Verde - Atlantic/Cape_Verde',
    value: 'Atlantic/Cape_Verde',
  },
  {
    countryName: 'Curaçao',
    name: 'Curaçao - America/Curacao',
    value: 'America/Curacao',
  },
  {
    countryName: 'Christmas Island',
    name: 'Christmas Island - Indian/Christmas',
    value: 'Indian/Christmas',
  },
  {
    countryName: 'Cyprus',
    name: 'Cyprus - Asia/Famagusta',
    value: 'Asia/Famagusta',
  },
  {
    countryName: 'Cyprus',
    name: 'Cyprus - Asia/Nicosia',
    value: 'Asia/Nicosia',
  },
  {
    countryName: 'Czech Republic',
    name: 'Czech Republic - Europe/Prague',
    value: 'Europe/Prague',
    countryCode: 'CZ',
  },
  {
    countryName: 'Germany',
    name: 'Germany - Europe/Berlin',
    value: 'Europe/Berlin',
    countryCode: 'DE',
  },
  {
    countryName: 'Germany',
    name: 'Germany - Europe/Busingen',
    value: 'Europe/Busingen',
    countryCode: 'DE',
  },
  {
    countryName: 'Djibouti',
    name: 'Djibouti - Africa/Djibouti',
    value: 'Africa/Djibouti',
    countryCode: 'DJ',
  },
  {
    countryName: 'Denmark',
    name: 'Denmark - Europe/Copenhagen',
    value: 'Europe/Copenhagen',
    countryCode: 'DK',
  },
  {
    countryName: 'Dominica',
    name: 'Dominica - America/Dominica',
    value: 'America/Dominica',
  },
  {
    countryName: 'Dominican Republic',
    name: 'Dominican Republic - America/Santo_Domingo',
    value: 'America/Santo_Domingo',
    countryCode: 'DO',
  },
  {
    countryName: 'Algeria',
    name: 'Algeria - Africa/Algiers',
    value: 'Africa/Algiers',
    countryCode: 'DZ',
  },
  {
    countryName: 'Ecuador',
    name: 'Ecuador - America/Guayaquil',
    value: 'America/Guayaquil',
    countryCode: 'EC',
  },
  {
    countryName: 'Ecuador',
    name: 'Ecuador - Pacific/Galapagos',
    value: 'Pacific/Galapagos',
    countryCode: 'EC',
  },
  {
    countryName: 'Estonia',
    name: 'Estonia - Europe/Tallinn',
    value: 'Europe/Tallinn',
    countryCode: 'EE',
  },
  {
    countryName: 'Egypt',
    name: 'Egypt - Africa/Cairo',
    value: 'Africa/Cairo',
    countryCode: 'EG',
  },
  {
    countryName: 'Western Sahara',
    name: 'Western Sahara - Africa/El_Aaiun',
    value: 'Africa/El_Aaiun',
  },
  {
    countryName: 'Eritrea',
    name: 'Eritrea - Africa/Asmara',
    value: 'Africa/Asmara',
    countryCode: 'ER',
  },
  {
    countryName: 'Spain',
    name: 'Spain - Africa/Ceuta',
    value: 'Africa/Ceuta',
    countryCode: 'ES',
  },
  {
    countryName: 'Spain',
    name: 'Spain - Atlantic/Canary',
    value: 'Atlantic/Canary',
    countryCode: 'ES',
  },
  {
    countryName: 'Spain',
    name: 'Spain - Europe/Madrid',
    value: 'Europe/Madrid',
    countryCode: 'ES',
  },
  {
    countryName: 'Ethiopia',
    name: 'Ethiopia - Africa/Addis_Ababa',
    value: 'Africa/Addis_Ababa',
    countryCode: 'ET',
  },
  {
    countryName: 'Finland',
    name: 'Finland - Europe/Helsinki',
    value: 'Europe/Helsinki',
    countryCode: 'FI',
  },
  {
    countryName: 'Fiji',
    name: 'Fiji - Pacific/Fiji',
    value: 'Pacific/Fiji',
  },
  {
    countryName: 'Falkland Islands',
    name: 'Falkland Islands - Atlantic/Stanley',
    value: 'Atlantic/Stanley',
  },
  {
    countryName: 'Micronesia',
    name: 'Micronesia - Pacific/Chuuk',
    value: 'Pacific/Chuuk',
  },
  {
    countryName: 'Micronesia',
    name: 'Micronesia - Pacific/Kosrae',
    value: 'Pacific/Kosrae',
  },
  {
    countryName: 'Micronesia',
    name: 'Micronesia - Pacific/Pohnpei',
    value: 'Pacific/Pohnpei',
  },
  {
    countryName: 'Faroe Islands',
    name: 'Faroe Islands - Atlantic/Faroe',
    value: 'Atlantic/Faroe',
    countryCode: 'FO',
  },
  {
    countryName: 'France',
    name: 'France - Europe/Paris',
    value: 'Europe/Paris',
    countryCode: 'FR',
  },
  {
    countryName: 'Gabon',
    name: 'Gabon - Africa/Libreville',
    value: 'Africa/Libreville',
  },
  {
    countryName: 'United Kingdom',
    name: 'United Kingdom - Europe/London',
    value: 'Europe/London',
    countryCode: 'GB',
  },
  {
    countryName: 'Grenada',
    name: 'Grenada - America/Grenada',
    value: 'America/Grenada',
  },
  {
    countryName: 'Georgia',
    name: 'Georgia - Asia/Tbilisi',
    value: 'Asia/Tbilisi',
    countryCode: 'GE',
  },
  {
    countryName: 'French Guiana',
    name: 'French Guiana - America/Cayenne',
    value: 'America/Cayenne',
  },
  {
    countryName: 'Guernsey',
    name: 'Guernsey - Europe/Guernsey',
    value: 'Europe/Guernsey',
  },
  {
    countryName: 'Ghana',
    name: 'Ghana - Africa/Accra',
    value: 'Africa/Accra',
  },
  {
    countryName: 'Gibraltar',
    name: 'Gibraltar - Europe/Gibraltar',
    value: 'Europe/Gibraltar',
  },
  {
    countryName: 'Greenland',
    name: 'Greenland - America/Danmarkshavn',
    value: 'America/Danmarkshavn',
    countryCode: 'GL',
  },
  {
    countryName: 'Greenland',
    name: 'Greenland - America/Godthab',
    value: 'America/Godthab',
    countryCode: 'GL',
  },
  {
    countryName: 'Greenland',
    name: 'Greenland - America/Scoresbysund',
    value: 'America/Scoresbysund',
    countryCode: 'GL',
  },
  {
    countryName: 'Greenland',
    name: 'Greenland - America/Thule',
    value: 'America/Thule',
    countryCode: 'GL',
  },
  {
    countryName: 'Gambia',
    name: 'Gambia - Africa/Banjul',
    value: 'Africa/Banjul',
  },
  {
    countryName: 'Guinea',
    name: 'Guinea - Africa/Conakry',
    value: 'Africa/Conakry',
  },
  {
    countryName: 'Guadeloupe',
    name: 'Guadeloupe - America/Guadeloupe',
    value: 'America/Guadeloupe',
  },
  {
    countryName: 'Equatorial Guinea',
    name: 'Equatorial Guinea - Africa/Malabo',
    value: 'Africa/Malabo',
  },
  {
    countryName: 'Greece',
    name: 'Greece - Europe/Athens',
    value: 'Europe/Athens',
    countryCode: 'GR',
  },
  {
    countryName: 'South Georgia and the South Sandwich Islands',
    name:
      'South Georgia and the South Sandwich Islands - Atlantic/South_Georgia',
    value: 'Atlantic/South_Georgia',
  },
  {
    countryName: 'Guatemala',
    name: 'Guatemala - America/Guatemala',
    value: 'America/Guatemala',
    countryCode: 'GT',
  },
  {
    countryName: 'Guam',
    name: 'Guam - Pacific/Guam',
    value: 'Pacific/Guam',
  },
  {
    countryName: 'Guinea',
    name: 'Guinea-Bissau - Africa/Bissau',
    value: 'Africa/Bissau',
  },
  {
    countryName: 'Guyana',
    name: 'Guyana - America/Guyana',
    value: 'America/Guyana',
  },
  {
    countryName: 'Hong Kong',
    name: 'Hong Kong - Asia/Hong_Kong',
    value: 'Asia/Hong_Kong',
    countryCode: 'HK',
  },
  {
    countryName: 'Honduras',
    name: 'Honduras - America/Tegucigalpa',
    value: 'America/Tegucigalpa',
    countryCode: 'HN',
  },
  {
    countryName: 'Croatia',
    name: 'Croatia - Europe/Zagreb',
    value: 'Europe/Zagreb',
    countryCode: 'HR',
  },
  {
    countryName: 'Haiti',
    name: 'Haiti - America/Port-au-Prince',
    value: 'America/Port-au-Prince',
    countryCode: 'HT',
  },
  {
    countryName: 'Hungary',
    name: 'Hungary - Europe/Budapest',
    value: 'Europe/Budapest',
    countryCode: 'HU',
  },
  {
    countryName: 'Indonesia',
    name: 'Indonesia - Asia/Jakarta',
    value: 'Asia/Jakarta',
    countryCode: 'ID',
  },
  {
    countryName: 'Indonesia',
    name: 'Indonesia - Asia/Jayapura',
    value: 'Asia/Jayapura',
    countryCode: 'ID',
  },
  {
    countryName: 'Indonesia',
    name: 'Indonesia - Asia/Makassar',
    value: 'Asia/Makassar',
    countryCode: 'ID',
  },
  {
    countryName: 'Indonesia',
    name: 'Indonesia - Asia/Pontianak',
    value: 'Asia/Pontianak',
    countryCode: 'ID',
  },
  {
    countryName: 'Ireland',
    name: 'Ireland - Europe/Dublin',
    value: 'Europe/Dublin',
    countryCode: 'IE',
  },
  {
    countryName: 'Israel',
    name: 'Israel - Asia/Jerusalem',
    value: 'Asia/Jerusalem',
    countryCode: 'IL',
  },
  {
    countryName: 'Isle of Man',
    name: 'Isle of Man - Europe/Isle_of_Man',
    value: 'Europe/Isle_of_Man',
  },
  {
    countryName: 'India',
    name: 'India - Asia/Kolkata',
    value: 'Asia/Kolkata',
    countryCode: 'IN',
  },
  {
    countryName: 'India',
    name: 'India - Asia/Calcutta',
    value: 'Asia/Calcutta',
    countryCode: 'IN',
  },
  {
    countryName: 'British Indian Ocean Territory',
    name: 'British Indian Ocean Territory - Indian/Chagos',
    value: 'Indian/Chagos',
  },
  {
    countryName: 'Iraq',
    name: 'Iraq - Asia/Baghdad',
    value: 'Asia/Baghdad',
    countryCode: 'IQ',
  },
  {
    countryName: 'Iran',
    name: 'Iran - Asia/Tehran',
    value: 'Asia/Tehran',
    countryCode: 'IR',
  },
  {
    countryName: 'Iceland',
    name: 'Iceland - Atlantic/Reykjavik',
    value: 'Atlantic/Reykjavik',
    countryCode: 'IS',
  },
  {
    countryName: 'Italy',
    name: 'Italy - Europe/Rome',
    value: 'Europe/Rome',
    countryCode: 'IT',
  },
  {
    countryName: 'Jersey',
    name: 'Jersey - Europe/Jersey',
    value: 'Europe/Jersey',
  },
  {
    countryName: 'Jamaica',
    name: 'Jamaica - America/Jamaica',
    value: 'America/Jamaica',
    countryCode: 'JM',
  },
  {
    countryName: 'Jordan',
    name: 'Jordan - Asia/Amman',
    value: 'Asia/Amman',
    countryCode: 'JO',
  },
  {
    countryName: 'Japan',
    name: 'Japan - Asia/Tokyo',
    value: 'Asia/Tokyo',
    countryCode: 'JP',
  },
  {
    countryName: 'Kenya',
    name: 'Kenya - Africa/Nairobi',
    value: 'Africa/Nairobi',
    countryCode: 'KE',
  },
  {
    countryName: 'Kyrgyzstan',
    name: 'Kyrgyzstan - Asia/Bishkek',
    value: 'Asia/Bishkek',
    countryCode: 'KG',
  },
  {
    countryName: 'Cambodia',
    name: 'Cambodia - Asia/Phnom_Penh',
    value: 'Asia/Phnom_Penh',
    countryCode: 'KH',
  },
  {
    countryName: 'Kiribati',
    name: 'Kiribati - Pacific/Enderbury',
    value: 'Pacific/Enderbury',
  },
  {
    countryName: 'Kiribati',
    name: 'Kiribati - Pacific/Kiritimati',
    value: 'Pacific/Kiritimati',
  },
  {
    countryName: 'Kiribati',
    name: 'Kiribati - Pacific/Tarawa',
    value: 'Pacific/Tarawa',
  },
  {
    countryName: 'Comoros',
    name: 'Comoros - Indian/Comoro',
    value: 'Indian/Comoro',
  },
  {
    countryName: 'Saint Kitts and Nevis',
    name: 'Saint Kitts and Nevis - America/St_Kitts',
    value: 'America/St_Kitts',
  },
  {
    countryName: 'North Korea',
    name: 'North Korea - Asia/Pyongyang',
    value: 'Asia/Pyongyang',
  },
  {
    countryName: 'South Korea',
    name: 'South Korea - Asia/Seoul',
    value: 'Asia/Seoul',
    countryCode: 'KR',
  },
  {
    countryName: 'Kuwait',
    name: 'Kuwait - Asia/Kuwait',
    value: 'Asia/Kuwait',
    countryCode: 'KW',
  },
  {
    countryName: 'Cayman Islands',
    name: 'Cayman Islands - America/Cayman',
    value: 'America/Cayman',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Almaty',
    value: 'Asia/Almaty',
    countryCode: 'KZ',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Aqtau',
    value: 'Asia/Aqtau',
    countryCode: 'KZ',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Aqtobe',
    value: 'Asia/Aqtobe',
    countryCode: 'KZ',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Atyrau',
    value: 'Asia/Atyrau',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Oral',
    value: 'Asia/Oral',
    countryCode: 'KZ',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Qostanay',
    value: 'Asia/Qostanay',
  },
  {
    countryName: 'Kazakhstan',
    name: 'Kazakhstan - Asia/Qyzylorda',
    value: 'Asia/Qyzylorda',
    countryCode: 'KZ',
  },
  {
    countryName: 'Laos',
    name: 'Laos - Asia/Vientiane',
    value: 'Asia/Vientiane',
    countryCode: 'LA',
  },
  {
    countryName: 'Lebanon',
    name: 'Lebanon - Asia/Beirut',
    value: 'Asia/Beirut',
    countryCode: 'LB',
  },
  {
    countryName: 'Saint Lucia',
    name: 'Saint Lucia - America/St_Lucia',
    value: 'America/St_Lucia',
  },
  {
    countryName: 'Liechtenstein',
    name: 'Liechtenstein - Europe/Vaduz',
    value: 'Europe/Vaduz',
    countryCode: 'LI',
  },
  {
    countryName: 'Sri Lanka',
    name: 'Sri Lanka - Asia/Colombo',
    value: 'Asia/Colombo',
    countryCode: 'LK',
  },
  {
    countryName: 'Liberia',
    name: 'Liberia - Africa/Monrovia',
    value: 'Africa/Monrovia',
  },
  {
    countryName: 'Lesotho',
    name: 'Lesotho - Africa/Maseru',
    value: 'Africa/Maseru',
  },
  {
    countryName: 'Lithuania',
    name: 'Lithuania - Europe/Vilnius',
    value: 'Europe/Vilnius',
    countryCode: 'LT',
  },
  {
    countryName: 'Luxembourg',
    name: 'Luxembourg - Europe/Luxembourg',
    value: 'Europe/Luxembourg',
    countryCode: 'LU',
  },
  {
    countryName: 'Latvia',
    name: 'Latvia - Europe/Riga',
    value: 'Europe/Riga',
    countryCode: 'LV',
  },
  {
    countryName: 'Libya',
    name: 'Libya - Africa/Tripoli',
    value: 'Africa/Tripoli',
    countryCode: 'LY',
  },
  {
    countryName: 'Morocco',
    name: 'Morocco - Africa/Casablanca',
    value: 'Africa/Casablanca',
    countryCode: 'MA',
  },
  {
    countryName: 'Monaco',
    name: 'Monaco - Europe/Monaco',
    value: 'Europe/Monaco',
    countryCode: 'MC',
  },
  {
    countryName: 'Moldova',
    name: 'Moldova - Europe/Chisinau',
    value: 'Europe/Chisinau',
    countryCode: 'MD',
  },
  {
    countryName: 'Montenegro',
    name: 'Montenegro - Europe/Podgorica',
    value: 'Europe/Podgorica',
    countryCode: 'ME',
  },
  {
    countryName: 'Saint Martin',
    name: 'Saint Martin - America/Marigot',
    value: 'America/Marigot',
  },
  {
    countryName: 'Madagascar',
    name: 'Madagascar - Indian/Antananarivo',
    value: 'Indian/Antananarivo',
  },
  {
    countryName: 'Marshall Islands',
    name: 'Marshall Islands - Pacific/Kwajalein',
    value: 'Pacific/Kwajalein',
  },
  {
    countryName: 'Marshall Islands',
    name: 'Marshall Islands - Pacific/Majuro',
    value: 'Pacific/Majuro',
  },
  {
    countryName: 'Macedonia',
    name: 'Macedonia - Europe/Skopje',
    value: 'Europe/Skopje',
    countryCode: 'MK',
  },
  {
    countryName: 'Mali',
    name: 'Mali - Africa/Bamako',
    value: 'Africa/Bamako',
    countryCode: 'ML',
  },
  {
    countryName: 'Myanmar',
    name: 'Myanmar - Asia/Yangon',
    value: 'Asia/Yangon',
  },
  {
    countryName: 'Mongolia',
    name: 'Mongolia - Asia/Choibalsan',
    value: 'Asia/Choibalsan',
    countryCode: 'MN',
  },
  {
    countryName: 'Mongolia',
    name: 'Mongolia - Asia/Hovd',
    value: 'Asia/Hovd',
    countryCode: 'MN',
  },
  {
    countryName: 'Mongolia',
    name: 'Mongolia - Asia/Ulaanbaatar',
    value: 'Asia/Ulaanbaatar',
    countryCode: 'MN',
  },
  {
    countryName: 'Macao',
    name: 'Macao - Asia/Macau',
    value: 'Asia/Macau',
    countryCode: 'MO',
  },
  {
    countryName: 'Northern Mariana Islands',
    name: 'Northern Mariana Islands - Pacific/Saipan',
    value: 'Pacific/Saipan',
  },
  {
    countryName: 'Martinique',
    name: 'Martinique - America/Martinique',
    value: 'America/Martinique',
  },
  {
    countryName: 'Mauritania',
    name: 'Mauritania - Africa/Nouakchott',
    value: 'Africa/Nouakchott',
  },
  {
    countryName: 'Montserrat',
    name: 'Montserrat - America/Montserrat',
    value: 'America/Montserrat',
  },
  {
    countryName: 'Malta',
    name: 'Malta - Europe/Malta',
    value: 'Europe/Malta',
    countryCode: 'MT',
  },
  {
    countryName: 'Mauritius',
    name: 'Mauritius - Indian/Mauritius',
    value: 'Indian/Mauritius',
  },
  {
    countryName: 'Maldives',
    name: 'Maldives - Indian/Maldives',
    value: 'Indian/Maldives',
    countryCode: 'MV',
  },
  {
    countryName: 'Malawi',
    name: 'Malawi - Africa/Blantyre',
    value: 'Africa/Blantyre',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Bahia_Banderas',
    value: 'America/Bahia_Banderas',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Cancun',
    value: 'America/Cancun',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Chihuahua',
    value: 'America/Chihuahua',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Hermosillo',
    value: 'America/Hermosillo',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Matamoros',
    value: 'America/Matamoros',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Mazatlan',
    value: 'America/Mazatlan',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Merida',
    value: 'America/Merida',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Mexico_City',
    value: 'America/Mexico_City',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Monterrey',
    value: 'America/Monterrey',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Ojinaga',
    value: 'America/Ojinaga',
    countryCode: 'MX',
  },
  {
    countryName: 'Mexico',
    name: 'Mexico - America/Tijuana',
    value: 'America/Tijuana',
    countryCode: 'MX',
  },
  {
    countryName: 'Malaysia',
    name: 'Malaysia - Asia/Kuala_Lumpur',
    value: 'Asia/Kuala_Lumpur',
    countryCode: 'MY',
  },
  {
    countryName: 'Malaysia',
    name: 'Malaysia - Asia/Kuching',
    value: 'Asia/Kuching',
    countryCode: 'MY',
  },
  {
    countryName: 'Mozambique',
    name: 'Mozambique - Africa/Maputo',
    value: 'Africa/Maputo',
  },
  {
    countryName: 'Namibia',
    name: 'Namibia - Africa/Windhoek',
    value: 'Africa/Windhoek',
  },
  {
    countryName: 'New Caledonia',
    name: 'New Caledonia - Pacific/Noumea',
    value: 'Pacific/Noumea',
  },
  {
    countryName: 'Niger',
    name: 'Niger - Africa/Niamey',
    value: 'Africa/Niamey',
  },
  {
    countryName: 'Norfolk Island',
    name: 'Norfolk Island - Pacific/Norfolk',
    value: 'Pacific/Norfolk',
  },
  {
    countryName: 'Nigeria',
    name: 'Nigeria - Africa/Lagos',
    value: 'Africa/Lagos',
    countryCode: 'NG',
  },
  {
    countryName: 'Nicaragua',
    name: 'Nicaragua - America/Managua',
    value: 'America/Managua',
    countryCode: 'NI',
  },
  {
    countryName: 'Netherlands',
    name: 'Netherlands - Europe/Amsterdam',
    value: 'Europe/Amsterdam',
    countryCode: 'NL',
  },
  {
    countryName: 'Norway',
    name: 'Norway - Europe/Oslo',
    value: 'Europe/Oslo',
    countryCode: 'NO',
  },
  {
    countryName: 'Nepal',
    name: 'Nepal - Asia/Kathmandu',
    value: 'Asia/Kathmandu',
    countryCode: 'NP',
  },
  {
    countryName: 'Nauru',
    name: 'Nauru - Pacific/Nauru',
    value: 'Pacific/Nauru',
  },
  {
    countryName: 'Niue',
    name: 'Niue - Pacific/Niue',
    value: 'Pacific/Niue',
  },
  {
    countryName: 'New Zealand',
    name: 'New Zealand - Pacific/Auckland',
    value: 'Pacific/Auckland',
    countryCode: 'NZ',
  },
  {
    countryName: 'New Zealand',
    name: 'New Zealand - Pacific/Chatham',
    value: 'Pacific/Chatham',
    countryCode: 'NZ',
  },
  {
    countryName: 'Oman',
    name: 'Oman - Asia/Muscat',
    value: 'Asia/Muscat',
    countryCode: 'OM',
  },
  {
    countryName: 'Panama',
    name: 'Panama - America/Panama',
    value: 'America/Panama',
    countryCode: 'PA',
  },
  {
    countryName: 'Peru',
    name: 'Peru - America/Lima',
    value: 'America/Lima',
    countryCode: 'PE',
  },
  {
    countryName: 'French Polynesia',
    name: 'French Polynesia - Pacific/Gambier',
    value: 'Pacific/Gambier',
  },
  {
    countryName: 'French Polynesia',
    name: 'French Polynesia - Pacific/Marquesas',
    value: 'Pacific/Marquesas',
  },
  {
    countryName: 'French Polynesia',
    name: 'French Polynesia - Pacific/Tahiti',
    value: 'Pacific/Tahiti',
  },
  {
    countryName: 'Papua New Guinea',
    name: 'Papua New Guinea - Pacific/Bougainville',
    value: 'Pacific/Bougainville',
  },
  {
    countryName: 'Papua New Guinea',
    name: 'Papua New Guinea - Pacific/Port_Moresby',
    value: 'Pacific/Port_Moresby',
  },
  {
    countryName: 'Philippines',
    name: 'Philippines - Asia/Manila',
    value: 'Asia/Manila',
    countryCode: 'PH',
  },
  {
    countryName: 'Pakistan',
    name: 'Pakistan - Asia/Karachi',
    value: 'Asia/Karachi',
    countryCode: 'PK',
  },
  {
    countryName: 'Poland',
    name: 'Poland - Europe/Warsaw',
    value: 'Europe/Warsaw',
    countryCode: 'PL',
  },
  {
    countryName: 'Saint Pierre and Miquelon',
    name: 'Saint Pierre and Miquelon - America/Miquelon',
    value: 'America/Miquelon',
  },
  {
    countryName: 'Pitcairn',
    name: 'Pitcairn - Pacific/Pitcairn',
    value: 'Pacific/Pitcairn',
  },
  {
    countryName: 'Puerto Rico',
    name: 'Puerto Rico - America/Puerto_Rico',
    value: 'America/Puerto_Rico',
    countryCode: 'PR',
  },
  {
    countryName: 'Palestinian Territory',
    name: 'Palestinian Territory - Asia/Gaza',
    value: 'Asia/Gaza',
  },
  {
    countryName: 'Palestinian Territory',
    name: 'Palestinian Territory - Asia/Hebron',
    value: 'Asia/Hebron',
  },
  {
    countryName: 'Portugal',
    name: 'Portugal - Atlantic/Azores',
    value: 'Atlantic/Azores',
    countryCode: 'PT',
  },
  {
    countryName: 'Portugal',
    name: 'Portugal - Atlantic/Madeira',
    value: 'Atlantic/Madeira',
    countryCode: 'PT',
  },
  {
    countryName: 'Portugal',
    name: 'Portugal - Europe/Lisbon',
    value: 'Europe/Lisbon',
    countryCode: 'PT',
  },
  {
    countryName: 'Palau',
    name: 'Palau - Pacific/Palau',
    value: 'Pacific/Palau',
  },
  {
    countryName: 'Paraguay',
    name: 'Paraguay - America/Asuncion',
    value: 'America/Asuncion',
    countryCode: 'PY',
  },
  {
    countryName: 'Qatar',
    name: 'Qatar - Asia/Qatar',
    value: 'Asia/Qatar',
    countryCode: 'QA',
  },
  {
    countryName: 'Reunion',
    name: 'Reunion - Indian/Reunion',
    value: 'Indian/Reunion',
    countryCode: 'RE',
  },
  {
    countryName: 'Romania',
    name: 'Romania - Europe/Bucharest',
    value: 'Europe/Bucharest',
    countryCode: 'RO',
  },
  {
    countryName: 'Serbia',
    name: 'Serbia - Europe/Belgrade',
    value: 'Europe/Belgrade',
    countryCode: 'RS',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Anadyr',
    value: 'Asia/Anadyr',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Barnaul',
    value: 'Asia/Barnaul',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Chita',
    value: 'Asia/Chita',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Irkutsk',
    value: 'Asia/Irkutsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Kamchatka',
    value: 'Asia/Kamchatka',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Khandyga',
    value: 'Asia/Khandyga',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Krasnoyarsk',
    value: 'Asia/Krasnoyarsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Magadan',
    value: 'Asia/Magadan',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Novokuznetsk',
    value: 'Asia/Novokuznetsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Novosibirsk',
    value: 'Asia/Novosibirsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Omsk',
    value: 'Asia/Omsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Sakhalin',
    value: 'Asia/Sakhalin',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Srednekolymsk',
    value: 'Asia/Srednekolymsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Tomsk',
    value: 'Asia/Tomsk',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Ust-Nera',
    value: 'Asia/Ust-Nera',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Vladivostok',
    value: 'Asia/Vladivostok',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Yakutsk',
    value: 'Asia/Yakutsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Asia/Yekaterinburg',
    value: 'Asia/Yekaterinburg',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Astrakhan',
    value: 'Europe/Astrakhan',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Kaliningrad',
    value: 'Europe/Kaliningrad',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Kirov',
    value: 'Europe/Kirov',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Moscow',
    value: 'Europe/Moscow',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Samara',
    value: 'Europe/Samara',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Saratov',
    value: 'Europe/Saratov',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Ulyanovsk',
    value: 'Europe/Ulyanovsk',
    countryCode: 'RU',
  },
  {
    countryName: 'Russia',
    name: 'Russia - Europe/Volgograd',
    value: 'Europe/Volgograd',
    countryCode: 'RU',
  },
  {
    countryName: 'Rwanda',
    name: 'Rwanda - Africa/Kigali',
    value: 'Africa/Kigali',
    countryCode: 'RW',
  },
  {
    countryName: 'Saudi Arabia',
    name: 'Saudi Arabia - Asia/Riyadh',
    value: 'Asia/Riyadh',
    countryCode: 'SA',
  },
  {
    countryName: 'Solomon Islands',
    name: 'Solomon Islands - Pacific/Guadalcanal',
    value: 'Pacific/Guadalcanal',
  },
  {
    countryName: 'Seychelles',
    name: 'Seychelles - Indian/Mahe',
    value: 'Indian/Mahe',
  },
  {
    countryName: 'Sudan',
    name: 'Sudan - Africa/Khartoum',
    value: 'Africa/Khartoum',
  },
  {
    countryName: 'Sweden',
    name: 'Sweden - Europe/Stockholm',
    value: 'Europe/Stockholm',
    countryCode: 'SE',
  },
  {
    countryName: 'Singapore',
    name: 'Singapore - Asia/Singapore',
    value: 'Asia/Singapore',
    countryCode: 'SG',
  },
  {
    countryName: 'Saint Helena',
    name: 'Saint Helena - Atlantic/St_Helena',
    value: 'Atlantic/St_Helena',
  },
  {
    countryName: 'Slovenia',
    name: 'Slovenia - Europe/Ljubljana',
    value: 'Europe/Ljubljana',
    countryCode: 'SI',
  },
  {
    countryName: 'Svalbard and Jan Mayen',
    name: 'Svalbard and Jan Mayen - Arctic/Longyearbyen',
    value: 'Arctic/Longyearbyen',
  },
  {
    countryName: 'Slovakia',
    name: 'Slovakia - Europe/Bratislava',
    value: 'Europe/Bratislava',
    countryCode: 'SK',
  },
  {
    countryName: 'Sierra Leone',
    name: 'Sierra Leone - Africa/Freetown',
    value: 'Africa/Freetown',
  },
  {
    countryName: 'San Marino',
    name: 'San Marino - Europe/San_Marino',
    value: 'Europe/San_Marino',
  },
  {
    countryName: 'Senegal',
    name: 'Senegal - Africa/Dakar',
    value: 'Africa/Dakar',
    countryCode: 'SN',
  },
  {
    countryName: 'Somalia',
    name: 'Somalia - Africa/Mogadishu',
    value: 'Africa/Mogadishu',
    countryCode: 'SO',
  },
  {
    countryName: 'Suriname',
    name: 'Suriname - America/Paramaribo',
    value: 'America/Paramaribo',
  },
  {
    countryName: 'South Sudan',
    name: 'South Sudan - Africa/Juba',
    value: 'Africa/Juba',
  },
  {
    countryName: 'Sao Tome and Principe',
    name: 'Sao Tome and Principe - Africa/Sao_Tome',
    value: 'Africa/Sao_Tome',
  },
  {
    countryName: 'El Salvador',
    name: 'El Salvador - America/El_Salvador',
    value: 'America/El_Salvador',
    countryCode: 'SV',
  },
  {
    countryName: 'Sint Maarten',
    name: 'Sint Maarten - America/Lower_Princes',
    value: 'America/Lower_Princes',
  },
  {
    countryName: 'Syria',
    name: 'Syria - Asia/Damascus',
    value: 'Asia/Damascus',
    countryCode: 'SY',
  },
  {
    countryName: 'Swaziland',
    name: 'Swaziland - Africa/Mbabane',
    value: 'Africa/Mbabane',
  },
  {
    countryName: 'Turks and Caicos Islands',
    name: 'Turks and Caicos Islands - America/Grand_Turk',
    value: 'America/Grand_Turk',
  },
  {
    countryName: 'Chad',
    name: 'Chad - Africa/Ndjamena',
    value: 'Africa/Ndjamena',
  },
  {
    countryName: 'French Southern Territories',
    name: 'French Southern Territories - Indian/Kerguelen',
    value: 'Indian/Kerguelen',
  },
  {
    countryName: 'Togo',
    name: 'Togo - Africa/Lome',
    value: 'Africa/Lome',
  },
  {
    countryName: 'Thailand',
    name: 'Thailand - Asia/Bangkok',
    value: 'Asia/Bangkok',
    countryCode: 'TH',
  },
  {
    countryName: 'Tajikistan',
    name: 'Tajikistan - Asia/Dushanbe',
    value: 'Asia/Dushanbe',
    countryCode: 'TJ',
  },
  {
    countryName: 'Tokelau',
    name: 'Tokelau - Pacific/Fakaofo',
    value: 'Pacific/Fakaofo',
  },
  {
    countryName: 'East Timor',
    name: 'East Timor - Asia/Dili',
    value: 'Asia/Dili',
  },
  {
    countryName: 'Turkmenistan',
    name: 'Turkmenistan - Asia/Ashgabat',
    value: 'Asia/Ashgabat',
    countryCode: 'TM',
  },
  {
    countryName: 'Tunisia',
    name: 'Tunisia - Africa/Tunis',
    value: 'Africa/Tunis',
    countryCode: 'TN',
  },
  {
    countryName: 'Tonga',
    name: 'Tonga - Pacific/Tongatapu',
    value: 'Pacific/Tongatapu',
  },
  {
    countryName: 'Turkey',
    name: 'Turkey - Europe/Istanbul',
    value: 'Europe/Istanbul',
    countryCode: 'TR',
  },
  {
    countryName: 'Trinidad and Tobago',
    name: 'Trinidad and Tobago - America/Port_of_Spain',
    value: 'America/Port_of_Spain',
    countryCode: 'TT',
  },
  {
    countryName: 'Tuvalu',
    name: 'Tuvalu - Pacific/Funafuti',
    value: 'Pacific/Funafuti',
  },
  {
    countryName: 'Taiwan',
    name: 'Taiwan - Asia/Taipei',
    value: 'Asia/Taipei',
    countryCode: 'TW',
  },
  {
    countryName: 'Tanzania',
    name: 'Tanzania - Africa/Dar_es_Salaam',
    value: 'Africa/Dar_es_Salaam',
  },
  {
    countryName: 'Ukraine',
    name: 'Ukraine - Europe/Kiev',
    value: 'Europe/Kiev',
    countryCode: 'UA',
  },
  {
    countryName: 'Ukraine',
    name: 'Ukraine - Europe/Simferopol',
    value: 'Europe/Simferopol',
    countryCode: 'RU',
  },
  {
    countryName: 'Ukraine',
    name: 'Ukraine - Europe/Uzhgorod',
    value: 'Europe/Uzhgorod',
    countryCode: 'UA',
  },
  {
    countryName: 'Ukraine',
    name: 'Ukraine - Europe/Zaporozhye',
    value: 'Europe/Zaporozhye',
    countryCode: 'UA',
  },
  {
    countryName: 'Uganda',
    name: 'Uganda - Africa/Kampala',
    value: 'Africa/Kampala',
  },
  {
    countryName: 'United States Minor Outlying Islands',
    name: 'United States Minor Outlying Islands - Pacific/Midway',
    value: 'Pacific/Midway',
  },
  {
    countryName: 'United States Minor Outlying Islands',
    name: 'United States Minor Outlying Islands - Pacific/Wake',
    value: 'Pacific/Wake',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Adak',
    value: 'America/Adak',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Anchorage',
    value: 'America/Anchorage',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Boise',
    value: 'America/Boise',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Chicago',
    value: 'America/Chicago',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Denver',
    value: 'America/Denver',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Detroit',
    value: 'America/Detroit',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Indianapolis',
    value: 'America/Indiana/Indianapolis',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Knox',
    value: 'America/Indiana/Knox',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Marengo',
    value: 'America/Indiana/Marengo',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Petersburg',
    value: 'America/Indiana/Petersburg',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Tell_City',
    value: 'America/Indiana/Tell_City',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Vevay',
    value: 'America/Indiana/Vevay',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Vincennes',
    value: 'America/Indiana/Vincennes',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Indiana/Winamac',
    value: 'America/Indiana/Winamac',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Juneau',
    value: 'America/Juneau',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Kentucky/Louisville',
    value: 'America/Kentucky/Louisville',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Kentucky/Monticello',
    value: 'America/Kentucky/Monticello',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Los_Angeles',
    value: 'America/Los_Angeles',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Menominee',
    value: 'America/Menominee',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Metlakatla',
    value: 'America/Metlakatla',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/New_York',
    value: 'America/New_York',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Nome',
    value: 'America/Nome',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/North_Dakota/Beulah',
    value: 'America/North_Dakota/Beulah',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/North_Dakota/Center',
    value: 'America/North_Dakota/Center',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/North_Dakota/New_Salem',
    value: 'America/North_Dakota/New_Salem',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Phoenix',
    value: 'America/Phoenix',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Sitka',
    value: 'America/Sitka',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - America/Yakutat',
    value: 'America/Yakutat',
    countryCode: 'US',
  },
  {
    countryName: 'United States',
    name: 'United States - Pacific/Honolulu',
    value: 'Pacific/Honolulu',
    countryCode: 'US',
  },
  {
    countryName: 'Uruguay',
    name: 'Uruguay - America/Montevideo',
    value: 'America/Montevideo',
    countryCode: 'UY',
  },
  {
    countryName: 'Uzbekistan',
    name: 'Uzbekistan - Asia/Samarkand',
    value: 'Asia/Samarkand',
    countryCode: 'UZ',
  },
  {
    countryName: 'Uzbekistan',
    name: 'Uzbekistan - Asia/Tashkent',
    value: 'Asia/Tashkent',
    countryCode: 'UZ',
  },
  {
    countryName: 'Vatican',
    name: 'Vatican - Europe/Vatican',
    value: 'Europe/Vatican',
  },
  {
    countryName: 'Saint Vincent and the Grenadines',
    name: 'Saint Vincent and the Grenadines - America/St_Vincent',
    value: 'America/St_Vincent',
  },
  {
    countryName: 'Venezuela',
    name: 'Venezuela - America/Caracas',
    value: 'America/Caracas',
    countryCode: 'VE',
  },
  {
    countryName: 'British Virgin Islands',
    name: 'British Virgin Islands - America/Tortola',
    value: 'America/Tortola',
  },
  {
    countryName: 'U.S. Virgin Islands',
    name: 'U.S. Virgin Islands - America/St_Thomas',
    value: 'America/St_Thomas',
  },
  {
    countryName: 'Vietnam',
    name: 'Vietnam - Asia/Ho_Chi_Minh',
    value: 'Asia/Ho_Chi_Minh',
    countryCode: 'VN',
  },
  {
    countryName: 'Vanuatu',
    name: 'Vanuatu - Pacific/Efate',
    value: 'Pacific/Efate',
  },
  {
    countryName: 'Wallis and Futuna',
    name: 'Wallis and Futuna - Pacific/Wallis',
    value: 'Pacific/Wallis',
  },
  {
    countryName: 'Samoa',
    name: 'Samoa - Pacific/Apia',
    value: 'Pacific/Apia',
  },
  {
    countryName: 'Yemen',
    name: 'Yemen - Asia/Aden',
    value: 'Asia/Aden',
    countryCode: 'YE',
  },
  {
    countryName: 'Mayotte',
    name: 'Mayotte - Indian/Mayotte',
    value: 'Indian/Mayotte',
  },
  {
    countryName: 'South Africa',
    name: 'South Africa - Africa/Johannesburg',
    value: 'Africa/Johannesburg',
    countryCode: 'ZA',
  },
  {
    countryName: 'Zambia',
    name: 'Zambia - Africa/Lusaka',
    value: 'Africa/Lusaka',
  },
  {
    countryName: 'Zimbabwe',
    name: 'Zimbabwe - Africa/Harare',
    value: 'Africa/Harare',
    countryCode: 'ZW',
  },
];

export const countryOptions: TCountryOption[] = Countries.map((item) => ({
  label: item.name,
  value: item.value,
  countryCode: item.countryCode,
}));

export default Countries;
